import { useComputed } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const CreateConfigTemplateModal = ({ showSignal, configTemplateListSignal, schemaVersionsSignal, newConfigTemplateNameSignal, newConfigTemplateVersionSignal, handleSubmit }) => {

    const configTemplateNamesComputed = useComputed(() => {
        if (configTemplateListSignal.value) {
            return configTemplateListSignal.value.map((p) => p.name)
        }
        return []
    })

    const nameAlreadyUsedComputed = useComputed(() => {
        return configTemplateNamesComputed.value.length && configTemplateNamesComputed.value.includes(newConfigTemplateNameSignal.value)
    })

    const disableSubmitComputed = useComputed(() => {
        return (newConfigTemplateNameSignal.value?.length == 0 || nameAlreadyUsedComputed.value)
    })

    const schemaVersionsDropdownOptionsComputed = useComputed(() => {
        if (schemaVersionsSignal?.value) {
            return schemaVersionsSignal.value.map((p) =>
                <option key={p.version} value={p.version}>{p.version}</option>
            )
        }
        return []
    })

    function UtgVersionSelect() {
        if (schemaVersionsSignal?.value) {
            let sorted = schemaVersionsSignal.value.sort((a, b) => {
                const trackga = "Track GA (Currently "
                const v1 = a.version
                if (v1.startsWith(trackga)) {
                    return -1
                }
                const v2 = b.version
                if (v2.startsWith(trackga)) {
                    return 1
                }
                else if (v1 < v2) {
                    return -1
                }
                return 1
            })
            let items = sorted.map(a => {
                return (
                    <option value={extractVersion(a.version)} key={extractVersion(a.version)}>{a.version}</option>
                )
            })
            return items
        }
    }

    const extractVersion = (versionString) => {
        if (typeof versionString != 'string') {
            return null
        }
        if (/^\d+\.\d+\.\d+\.\d+$/.test(versionString)) {
            return versionString; // Return it directly if it's already a version
        }
        // Extract version number from "Track GA (Currently: X.X.X.X)"
        const match = versionString.match(/(\d+\.\d+\.\d+\.\d+)/);
        return match ? match[0] : null; // Return extracted version or null if not found
    }

    return (
        <Modal show={showSignal.value} onHide={() => showSignal.value = false}>
            <Modal.Header closeButton>
                <Modal.Title>New Config Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Config Template Name</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onInput={(e) => newConfigTemplateNameSignal.value = e.target.value}
                            autoFocus
                            value={newConfigTemplateNameSignal.value}
                        />
                        <p className="mt-1" hidden={!nameAlreadyUsedComputed.value}>Config template name must be unique</p>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                        <Form.Label>Schema Version</Form.Label>
                        <Form.Control
                            as="select"
                            required
                            onInput={(e) => newConfigTemplateVersionSignal.value = e.target.value}
                            value={newConfigTemplateVersionSignal.value}
                        >
                            <option value="">Select Schema Version</option>
                            {UtgVersionSelect()}
                        </Form.Control>
                        <p className="mt-1" hidden={!!newConfigTemplateVersionSignal.value?.length}>Schema version is required</p>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => showSignal.value = false}>
                    Cancel
                </Button>
                <Button disabled={disableSubmitComputed.value} variant="primary" onClick={handleSubmit}>
                    Add New
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default CreateConfigTemplateModal